import {DrawText} from '@platform/ui/DrawReference';
import type {Snapshot} from '@platform/contracts/x';
import {drawNumber} from '@platform/contracts/drawNumber';
import {useCountdown} from '@platform/client';
import {useCopy,useUi} from '@platform/ui/config';
import {BottomCta} from './BottomCta';
import './DrawStartingCta.css';

// The broadcast clock and the existing sound sequence use this same server
// deadline. Each second restarts one visual beat; this footer never plays audio.
export function DrawStartingCta({state}:{state:Snapshot}){
 const t=useCopy(),ui=useUi();
 const seconds=useCountdown(state,state.drawCountdownEndsAtUtc??state.drawStartsAtUtc);
 const label=t('room.drawStartingPrompt').toLocaleUpperCase(ui.controls.prizeDisplayLocale);
 return <BottomCta className="room-next-action" revealKey={state.drawId+':starting'} data-ui="draw-starting-cta">
  <p className="draw-starting-message" role="status" aria-live="off">
   <small className="draw-starting-number" data-ui="draw-starting-number" style={{color:ui.tokens['--room-accent']}}><DrawText copyKey="room.selectionDraw" draw={drawNumber(state)}/></small>
   <span className="bottom-cta-blink" key={seconds} data-ticking={seconds>0&&seconds<=10}>{label}</span>
  </p>
 </BottomCta>;
}
